import React, { useEffect, useLayoutEffect, useState } from 'react'
import { Card, Col, Divider, Row, Select, Table, Switch, Button, Tag, Tooltip, Input, DatePicker, message, Popconfirm, List, Statistic, Modal } from "antd";
import { makeStyles } from "@mui/styles";
import Message from "../../Components/common/Message";
import AuthService from "../../Components/auth/AuthService";
import moment from "moment";
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import { Pagination } from "@mui/material";
import { DATE_FORMAT, DEFAULT_DATE_FORMAT, InventorySuppliers, issuePriorities, maintenanceSuppliers, VATPercentages } from "../../Components/common/constants";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import dayjs from 'dayjs';
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button as UploadButton, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { extractOriginalFileName, formatCurrency, getNewFileName } from '../../Components/common/CommonFun';
import { CloudDownloadOutlined, DeleteFilled, ExportOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { domain, env, tms_uploads_bucket, tms_uploads_cdn } from '../../Components/config';
import qs from 'query-string';
import jsPDF from "jspdf";
import TextEditor from '../../Components/TextEditor/TextEditor';
import logo from '../../assets/images/prefectosblack.png';


const Auth = new AuthService();

const useStyles = makeStyles((theme) => ({
  dataSheet: {
    padding: "5px",
    "& .ant-input[disabled]": {
      background: "none",
      color: "black",
    },
    "& .ant-card .ant-card-body": {
      padding: "4px",
      backgroundColor: "rgb(240, 240, 240)",
    },
    "& .ant-card .ant-card-head": {
      padding: "0px 4px",
      // backgroundColor: "rgb(240, 240, 240)",
      minHeight: '40px'
    },
    "& .ant-select-disabled:where(.css-dev-only-do-not-override-byeoj0).ant-select:not(.ant-select-customize-input) .ant-select-selector":{
      background: "white",
      color: "black",
    },
    
    "& .ant-picker.ant-picker-disabled": {
      fontWeight: 500,
      background: "none",
      color: "black"
    },
    "& .ant-picker .ant-picker-input >input[disabled]": {
      color: "black"
    },

  },
}));

const PurchaseOrder = () => {
const classes = useStyles();
  var layoutDispatch = useLoadingDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const conversionData = location?.state?.conversionData;
  console.log('conversionData', conversionData);
  
  const { Option } = Select;
  const { TextArea } = Input;
  const [id, setId] = React.useState(params.id ? params.id : 0);
  
  
  const [loadMessage, setLoadMessage] = useState("");
  const [type, setType] = useState("");
  const [purchaseOrderDetail, setPurchaseOrderDetail] = useState({
    order_code: "",
    date: new Date(),
    notes: "",
    supplier: null,
    work_order_id: null,
    completed: null
  });
  const [files, setFiles] = useState([]);
  const [currentItemFiles, setCurrentItemFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);

  const [orderItems, setOrderItems] = useState([]);

  const [allItems, setAllItems] = useState([]);
  const [allWorkOrders, setAllWorkOrders] = useState([]);
  
    const getAllWorkOrders = async () => {
      showLoading(layoutDispatch);
      try {
        const response = await Auth.fetch(`/inventory/work-orders`);
        if (response) {
          hideLoading(layoutDispatch);
          if (response?.ack) {
            setAllWorkOrders(response?.work_orders);
          } else {
            setAllWorkOrders([])
          }
        }
      } catch (err) {
        console.log(err);
      } finally{
        hideLoading(layoutDispatch)
      }
    }
  
    const getAllItems = async () => {
      showLoading(layoutDispatch);
      try {
        const response = await Auth.fetch(`/inventory/inventory-items`);
        if (response) {
          hideLoading(layoutDispatch);
          if (response?.ack) {
            setAllItems(response?.inventory_items);
          } else {
            setAllItems([])
          }
        }
      } catch (err) {
        console.log(err);
      } finally{
        hideLoading(layoutDispatch)
      }
    }

    useLayoutEffect(() => {
      getAllItems();
      getAllWorkOrders();
    }, [])
  

  const handleSubmitImage = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    for (let file of acceptedFiles) {
      const randomString = Math.random().toString(36).substring(2, 10);
      const newFileName = getNewFileName(file.name)
      setFiles((prevFiles) => [
        ...prevFiles,
        {
          name: newFileName,
          display_name: newFileName,
          file: file,
          ContentType: file.type,
        },
      ]);
      setCurrentItemFiles((prevFiles) => [...prevFiles, newFileName]);
    }
  };

  const handleDeleteFile = (fileName) => {
    const updatedFiles = files?.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
    setCurrentItemFiles(currentItemFiles?.filter((item) => item !== fileName));
  };

  const handleDeleteCurrentFile = (itemToDelete) => {
    setCurrentItemFiles(
      currentItemFiles.filter((item) => item !== itemToDelete)
    );
    if (!deletedFiles.includes(itemToDelete)) {
      setDeletedFiles((prevDeletedFiles) => [
        ...prevDeletedFiles,
        itemToDelete,
      ]);
    }
  };

  const handleAddItem = () => {
    const newItem = {
      order_item: null,
      vat_percentage: 2,
      order_item_quantity: "",
      order_item_unit_price: "",
      order_item_vat: "",
      order_item_total: "",
    };
    setOrderItems([...orderItems, newItem]);
  };

  const handleRemoveItem = async (index, item) => {
      const list = [...orderItems];
      list.splice(index, 1);
      setOrderItems(list);
    };

    const handleInputChange = (index, event) => {
      const { name, value } = event.target;
      let newValue = value;
    
      // Update the order item based on user input
      const list = [...orderItems];
      list[index][name] = newValue;
    
      // Calculate VAT and total if the changed field is related to quantity or unit price
      const item = list[index];
      const quantity = parseFloat(item.order_item_quantity || 0);
      const unitPrice = parseFloat(item.order_item_unit_price || 0);
    
      // Calculate VAT amount (quantity * unit price)
      const vatAmount = quantity * unitPrice;
    
      // Calculate VAT based on the selected VAT percentage
      const vat_percentageItem = VATPercentages.find((vatItem) => vatItem.id == item.vat_percentage)
      console.log('vat_percentageItem', vat_percentageItem, item.vat_percentage);
      
      const vatPercentage = Number(vat_percentageItem?.percent || 0) / 100;
      const calculatedVat = vatAmount * vatPercentage;
    
      // Calculate the total (quantity * unit price) + VAT
      const total = vatAmount + calculatedVat;
    
      // Update the list with the calculated values
      list[index].order_item_vat = calculatedVat.toFixed(2); // store VAT value
      list[index].order_item_total = total.toFixed(2); // store total value
    
      // Update the state with the new list
      setOrderItems(list);
    };

  

    console.log('name order Items', orderItems);

    const getUploadUrl = async (file, recordID) => {
      const params = {
        bucket: tms_uploads_bucket,
        ContentType: file.file.type,
        Key: env + "/purchase-orders/" + recordID + "/" + file.name,
      };
      const response = await fetch(
        `${domain}/generate-put-url?${qs.stringify(params)}`,
        {
          headers: {
            "Content-Type": params.ContentType,
          },
        }
      );
      return response.json();
    };
  
    const uploadFileToS3 = async (uploadUrl, file, contentType) => {
      const response = await fetch(uploadUrl.putURL, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": contentType,
        },
      });
      if (response.status !== 200) {
        console.log('response', response);
        message.error("File upload failed.")
        throw new Error("File upload failed.");
      }
    };

    
      const handleSubmitPurchaseOrder = async () => {
          const isEmptyOrUndefined = (value) => value === '' || value === null || value === undefined;
          const validations = [
            { key: 'date', message: 'Please add order date' },
            { key: 'supplier', message: 'Please add supplier' },
          ];
      
          for (const { key, message: errorMessage } of validations) {
            if (isEmptyOrUndefined(purchaseOrderDetail?.[key])) {
              message.error(errorMessage);
              return;
            }
          }

          const requiredFields = [
            "order_item",
            "order_item_quantity",
            "order_item_unit_price",
          ];
          const isEmpty = orderItems.some((item) =>
            requiredFields.some((field) => !item[field])
          );
      
          if (isEmpty) {
            message.error("Please fill in all required fields for items.");
            setType("error");
            return;
          }
      
          showLoading(layoutDispatch);
          const isUpdate = id > 0;
          const dataToSend = {
            id: isUpdate ? id : undefined,
            order_date: moment(purchaseOrderDetail.date).format("YYYY-MM-DD"),
            notes: purchaseOrderDetail.notes,
            files: currentItemFiles ? currentItemFiles : [],
            supplier_id: purchaseOrderDetail.supplier,
            work_order_id: purchaseOrderDetail?.work_order_id,
            items: orderItems.map((item) => ({
              inventory_item_id: item.order_item,
              quantity: item.order_item_quantity,
              unit_price: item.order_item_unit_price,
              vat_percentage: VATPercentages.find((vatItem) => vatItem.id == item.vat_percentage).percent,
            })),
          }
          try {
            const method = isUpdate ? "PUT" : "POST";
            const res = await Auth.fetch("/inventory/purchase-order", {
              method: method,
              body: JSON.stringify(dataToSend),
            })
            if (res?.ack) {
              const record = isUpdate ? id : res?.record_id;
              console.log(res);
              const uploadPromises = []
              if (files.length > 0) {
                files.forEach((f) => {
                  uploadPromises.push(
                    getUploadUrl(f, record)
                      .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                      .catch(error => console.error("Error uploading file:", error))
                  );
                });
              }
              await Promise.all(uploadPromises);
              message.success(res?.message)
              navigate('/workshop_purchase_order')
            } else {
              message.error(res?.message)
            }
      
          } catch (err) {
            console.log(err);
          }
          finally {
            hideLoading(layoutDispatch);
          }
        };
      
        const handlePostPurchaseOrder = async () => {
          const isEmptyOrUndefined = (value) => value === '' || value === null || value === undefined;
          const validations = [
            { key: 'date', message: 'Please add order date' },
            { key: 'supplier', message: 'Please add supplier' },
          ];
      
          for (const { key, message: errorMessage } of validations) {
            if (isEmptyOrUndefined(purchaseOrderDetail?.[key])) {
              message.error(errorMessage);
              return;
            }
          }

          const requiredFields = [
            "order_item",
            "order_item_quantity",
            "order_item_unit_price",
          ];
          const isEmpty = orderItems.some((item) =>
            requiredFields.some((field) => !item[field])
          );
      
          if (isEmpty) {
            message.error("Please fill in all required fields for items.");
            setType("error");
            return;
          }

          if(orderItems.length < 1) {
            message.error("Please add at least one item to close the purchase order.");
            return;
          }
      
          showLoading(layoutDispatch);
          const dataToSend = {
            id: id,
            order_date: moment(purchaseOrderDetail.date).format("YYYY-MM-DD"),
            notes: purchaseOrderDetail.notes,
            files: currentItemFiles ? currentItemFiles : [],
            supplier_id: purchaseOrderDetail.supplier,
            
            items: orderItems.map((item) => ({
              inventory_item_id: item.order_item,
              quantity: item.order_item_quantity,
              unit_price: item.order_item_unit_price,
              vat_percentage: VATPercentages.find((vatItem) => vatItem.id == item.vat_percentage).percent,
            })),
          }
          const postDataToSend = {
            id: id,
          }
          try {
            const res = await Auth.fetch("/inventory/purchase-order", {
              method: "PUT",
              body: JSON.stringify(dataToSend),
            })
            if (res?.ack) {
              console.log(res);
              const uploadPromises = []
              if (files.length > 0) {
                files.forEach((f) => {
                  uploadPromises.push(
                    getUploadUrl(f, id)
                      .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                      .catch(error => console.error("Error uploading file:", error))
                  );
                });
              }
              await Promise.all(uploadPromises);
              const PostRes = await Auth.fetch("/inventory/post-purchase-order", {
                method: "POST",
                body: JSON.stringify(postDataToSend),
              })
              if (PostRes?.ack) {
                message.success(PostRes?.message)
                navigate('/workshop_purchase_order')
              } else {
                message.error(PostRes?.message)
              }
            } else {
              message.error(res?.message)
            }
      
          } catch (err) {
            console.log(err);
          }
          finally {
            hideLoading(layoutDispatch);
          }
        };


      const getDataByID = async () => {
          showLoading(layoutDispatch)
          try {
            const res = await Auth.fetch(`/inventory/purchase-order?id=${id}`)
            if (res?.ack) {
              setCurrentItemFiles(res?.purchase_order.files ? JSON.parse(res?.purchase_order.files) : [])
              setPurchaseOrderDetail((prevDetails) => ({
                ...prevDetails,
                order_code: res?.purchase_order.order_code,
                date: res?.purchase_order.order_date,
                notes: res?.purchase_order.notes,
                supplier: res?.purchase_order.supplier_id,
                work_order_id: res?.purchase_order?.work_order_id,
                completed: res?.purchase_order.posted_by > 0 ? true : false,
              }))
              
              setOrderItems(
                res?.purchase_order_items.map((item) => ({
                  ...item,
                  order_item: item.inventory_item_id,
                  vat_percentage: VATPercentages.find((vatItem) => vatItem.percent == item.vat_percentage).id,
                  order_item_quantity: item.quantity,
                  order_item_unit_price: item.unit_price,
                  // order_item_vat: item.quantity * item.unit_price * (item.vat_percentage / 100),
                  order_item_vat:  Number(
                    (item.quantity * item.unit_price * (item.vat_percentage / 100))?.toFixed(2)
                  ),
                  // order_item_total: item.quantity * item.unit_price * (1 + item.vat_percentage / 100),
                  order_item_total: Number(
                    (item.quantity * item.unit_price * (1 + item.vat_percentage / 100))?.toFixed(2)
                  ),
                }))
              );
            }
          } catch (err) {
            console.log(err);
          } finally {
            hideLoading(layoutDispatch)
          }
        }
    
        console.log('details',  purchaseOrderDetail);
        

    useEffect(() => {
      if (id > 0) {
        getDataByID();
        
      } else if (id == 'new' && conversionData != undefined) {
        setPurchaseOrderDetail((prevDetails) => ({
          ...prevDetails,
          work_order_id: Number(conversionData?.work_order_id)
        }))
        
        setOrderItems(
          conversionData?.order_items?.map((item) => ({
            ...item,
            order_item: item.inventory_item_id,
            vat_percentage: VATPercentages?.find((vatItem) => vatItem.id == item.vat_percentage)?.id,
            order_item_quantity: item.quantity,
            order_item_unit_price: item.unit_price,
            order_item_vat:  Number(
              (item.quantity * item.unit_price * (VATPercentages?.find((vatItem) => vatItem.id == item.vat_percentage)?.percent / 100)).toFixed(2)
            ),
            order_item_total: Number(
              (item.quantity * item.unit_price * (1 + VATPercentages?.find((vatItem) => vatItem.id == item.vat_percentage)?.percent / 100)).toFixed(2)
            ),
          }))
        );
      } else {
        setOrderItems([
          {
            order_item: null,
            vat_percentage: 2,
            order_item_quantity: "",
            order_item_unit_price: "",
            order_item_vat: "",
            order_item_total: "",
          },
        ]);
      }
      }, [id]);

      const calculateSums = () => {
        const totalVat = orderItems.reduce((sum, item) => {
          return sum + parseFloat(item?.order_item_vat || 0); 
        }, 0);
      
        const totalPrice = orderItems.reduce((sum, item) => {
          const quantity = parseFloat(item.order_item_quantity || 0);
          const unitPrice = parseFloat(item.order_item_unit_price || 0);
          return sum + (quantity * unitPrice); 
        }, 0);
      
        return { totalVat, totalPrice };
      };
      
      // Usage example in your component
      const { totalVat, totalPrice } = calculateSums();

      const data = [
        {
          title: 'Total',
          value: <span style={{ color: 'blue', fontWeight: "bold"}}>{formatCurrency(totalPrice)}</span>
        },
        {
          title: 'VAT',
          value: <span style={{ color: 'blue', fontWeight: "bold"}}>{formatCurrency(totalVat)}</span>
        },
        
        {
          title: 'Grand Total',
          value: <span style={{ color: 'red', fontWeight: "bold"}}>{formatCurrency(totalVat + totalPrice)}</span>
        },
      ];

      const order = {
          orderCode: purchaseOrderDetail.order_code,
          date: purchaseOrderDetail.date,
          supplier: InventorySuppliers.find(item => item.id == purchaseOrderDetail.supplier)?.title,
          workOrder: allWorkOrders.find(item => item.id == purchaseOrderDetail.work_order_id)?.work_order_code,
          notes: (purchaseOrderDetail.notes ?? '').replace(/<\/?[^>]+(>|$)/g, ""),
          items: orderItems.map(item => ({
            name: allItems?.find(items => items.id == item.order_item)?.item_name,
            quantity: item.order_item_quantity,
            unitPrice: item.order_item_unit_price ?? '',
            vatPercent: VATPercentages.find(vatItem => vatItem.id == item.vat_percentage)?.percent,
            vat: item.order_item_vat ?? '',
            total: item.order_item_total ?? '',
          }))
        };
      
      // const generatePurchaseOrderPDF = () => {
      //   const doc = new jsPDF();
        
      //   // Page dimensions
      //   const pageWidth = doc.internal.pageSize.getWidth();
      //   const pageMargin = 14;
        
      //   // Logo dimensions
      //   const logoWidth = 50;
      //   const logoHeight = 15;
        
      //   const img = new Image();
      //   img.src = logo;
        
      //   img.onload = function () {
      //     // Calculate dynamic content heights
      //     const maxWidth = pageWidth - 2 * pageMargin - 10;
      //     const wrappedNotes = doc.splitTextToSize(order.notes, maxWidth);
      //     const notesHeight = wrappedNotes.length * 5;
      //     const headerHeight = 114 + notesHeight; // Total height of header sections
        
      //     // Define reusable header drawing function
      //     const drawHeaderAndDetails = (doc) => {
      //       // Reset styles to defaults
      //       doc.setFont("helvetica", "normal");
      //       doc.setTextColor(0);
        
      //       // Company Logo
      //       doc.addImage(img, 'PNG', pageMargin, 12, logoWidth, logoHeight);
        
      //       // Title Section
      //       doc.setFont("helvetica", "italic");
      //       doc.setFontSize(24);
      //       doc.setTextColor(60);
      //       doc.text('Purchase Order', pageWidth - pageMargin, 22, { align: 'right' });
        
      //       doc.setFontSize(12);
      //       doc.setTextColor(120);
      //       doc.text('#' + order?.orderCode, pageWidth - pageMargin, 30, { align: 'right' });
        
      //       // Header Divider
      //       doc.setDrawColor(200);
      //       doc.setLineWidth(0.8);
      //       doc.line(pageMargin, 32, pageWidth - pageMargin, 32);
        
      //       // Order Details Box
      //       const boxStartY = 44;
      //       const boxEndY = boxStartY + 15 + notesHeight;
      //       doc.setDrawColor(230);
      //       doc.rect(pageMargin, boxStartY, pageWidth - 2 * pageMargin, boxEndY - boxStartY);
        
      //       // Order Fields
      //       const fields = [
      //         { label: 'Date', value: moment(order.date).format('YYYY-MM-DD') },
      //         { label: 'Supplier', value: order?.supplier },
      //         { label: 'Notes', value: '' } // Empty value for Notes, since we display it later
      //       ];
        
      //       fields.forEach((field, index) => {
      //         const colX = index % 2 === 0 ? pageMargin + 2 : pageWidth / 2 + 2;
      //         const rowY = boxStartY + 8 + Math.floor(index / 2) * 10;
        
      //         doc.setFontSize(10);
      //         doc.setFont("helvetica", "bold");
      //         doc.text(`${field.label}:`, colX, rowY);
        
      //         doc.setFont("helvetica", "normal");
      //         doc.text((field?.value ?? '').toString(), colX + 25, rowY);
      //       });
        
      //       // Adjust the width for the Notes section and increase maxWidth
      //       const maxNotesWidth = pageWidth - 2 * pageMargin - 40; // Wider width for Notes
      //       const wrappedNotes = doc.splitTextToSize(order.notes, maxNotesWidth);
        
      //       // Wrap and display the Notes content with the updated width
      //       doc.setFontSize(10);
      //       wrappedNotes.forEach((line, index) => {
      //         doc.text(line, pageMargin + 25, boxStartY + 18 + index * 5);
      //       });
        
      //       // Money Section
      //       const moneySectionStartY = boxEndY + 10;
      //       const moneySectionHeight = 24;
      //       const moneySectionWidth = 80;
      //       const moneySectionX = pageWidth - pageMargin - moneySectionWidth;
        
      //       doc.setDrawColor(230);
      //       doc.rect(moneySectionX, moneySectionStartY, moneySectionWidth, moneySectionHeight);
        
      //       const moneyFields = [
      //         { label: 'VAT', value: formatCurrency(totalVat) },
      //         { label: 'Total', value: formatCurrency(totalPrice) },
      //         { label: 'Grand Total', value: formatCurrency(totalVat + totalPrice) }
      //       ];
        
      //       moneyFields.forEach((field, index) => {
      //         const rowY = moneySectionStartY + 10 + index * 6;
      //         doc.setFontSize(10);
      //         doc.setFont("helvetica", "bold");
      //         doc.text(`${field.label}:`, moneySectionX + 12, rowY);
      //         doc.setFont("helvetica", "normal");
      //         doc.text(field.value, moneySectionX + moneySectionWidth - 10, rowY, { align: 'right' });
      //       });
        
      //       // Items Section Header
      //       const itemsTitleY = moneySectionStartY + moneySectionHeight + 6;
      //       doc.setFontSize(14);
      //       doc.text('Items', pageMargin, itemsTitleY);
      //       doc.setLineWidth(0.5);
      //       doc.line(pageMargin, itemsTitleY + 2, pageWidth - pageMargin, itemsTitleY + 2);
      //     };
        
      //     // Prepare table data
      //     const tableColumn = ["Item Name", "Quantity", "Unit Price", "VAT%", "VAT", "Total"];
      //     const tableRows = order.items.map(item => [
      //       item.name,
      //       item.quantity.toString(),
      //       formatCurrency(item.unitPrice || 0),
      //       item.vatPercent.toString(),
      //       formatCurrency(item.vat || 0),
      //       formatCurrency(item.total || 0),
      //     ]);
        
      //     // Generate table with repeating header
      //     doc.autoTable({
      //       startY: headerHeight -10,
      //       margin: { top: headerHeight },
      //       head: [tableColumn],
      //       body: tableRows,
      //       theme: 'grid',
      //       headStyles: {
      //         fillColor: [79, 129, 189],
      //         textColor: 255,
      //         fontSize: 10,
      //         align: 'center'
      //       },
      //       bodyStyles: { fontSize: 10 },
      //       willDrawPage: () => {
      //         // Draw header on every page before table
      //         drawHeaderAndDetails(doc);
      //       }
      //     });
        
      //     // Save PDF
      //     doc.save(`purchase_order_${order.orderCode}.pdf`);
      //   };
      // };
      
      
      const generatePurchaseOrderPDF = () => {
        const doc = new jsPDF();
      
        // Page dimensions
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageMargin = 14;
      
        // Logo dimensions
        const logoWidth = 50;
        const logoHeight = 15;
      
        const img = new Image();
        img.src = logo;
      
        img.onload = function () {
          // Calculate dynamic content heights
          const maxWidth = pageWidth - 2 * pageMargin - 10;
          const wrappedNotes = doc.splitTextToSize(order.notes, maxWidth);
          const notesHeight = wrappedNotes.length * 5;
          const headerHeight = 114 + notesHeight; // Total height of header sections
      
          // Define reusable header drawing function
          const drawHeaderAndDetails = (doc) => {
            // Reset styles to defaults
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0);
      
            // Company Logo
            doc.addImage(img, 'PNG', pageMargin, 12, logoWidth, logoHeight);
      
            // Title Section
            doc.setFont("helvetica", "italic");
            doc.setFontSize(24);
            doc.setTextColor(60);
            doc.text('Purchase Order', pageWidth - pageMargin, 22, { align: 'right' });
      
            doc.setFontSize(12);
            doc.setTextColor(120);
            doc.text('#' + order?.orderCode, pageWidth - pageMargin, 30, { align: 'right' });
      
            // Header Divider
            doc.setDrawColor(200);
            doc.setLineWidth(0.8);
            doc.line(pageMargin, 32, pageWidth - pageMargin, 32);
      
            // Order Details Box
            const boxStartY = 44;
            const boxEndY = boxStartY + 15 + notesHeight;
            doc.setDrawColor(230);
            doc.rect(pageMargin, boxStartY, pageWidth - 2 * pageMargin, boxEndY - boxStartY);
      
            // Order Fields
            const fields = [
              { label: 'Date', value: moment(order.date).format('YYYY-MM-DD') },
              { label: 'Supplier', value: order?.supplier },
              { label: 'Notes', value: '' } // Empty value for Notes, since we display it later
            ];
      
            fields.forEach((field, index) => {
              const colX = index % 2 === 0 ? pageMargin + 2 : pageWidth / 2 + 2;
              const rowY = boxStartY + 8 + Math.floor(index / 2) * 10;
      
              doc.setFontSize(10);
              doc.setFont("helvetica", "bold");
              doc.text(`${field.label}:`, colX, rowY);
      
              doc.setFont("helvetica", "normal");
              doc.text((field?.value ?? '').toString(), colX + 25, rowY);
            });
      
            // Adjust the width for the Notes section and increase maxWidth
            const maxNotesWidth = pageWidth - 2 * pageMargin - 40; // Wider width for Notes
            const wrappedNotes = doc.splitTextToSize(order.notes, maxNotesWidth);
      
            // Wrap and display the Notes content with the updated width
            doc.setFontSize(10);
            wrappedNotes.forEach((line, index) => {
              doc.text(line, pageMargin + 25, boxStartY + 18 + index * 5);
            });
      
            // Money Section
            const moneySectionStartY = boxEndY + 10;
            const moneySectionHeight = 24;
            const moneySectionWidth = 80;
            const moneySectionX = pageWidth - pageMargin - moneySectionWidth;
      
            doc.setDrawColor(230);
            doc.rect(moneySectionX, moneySectionStartY, moneySectionWidth, moneySectionHeight);
      
            const moneyFields = [
              { label: 'VAT', value: formatCurrency(totalVat) },
              { label: 'Total', value: formatCurrency(totalPrice) },
              { label: 'Grand Total', value: formatCurrency(totalVat + totalPrice) }
            ];
      
            moneyFields.forEach((field, index) => {
              const rowY = moneySectionStartY + 10 + index * 6;
              doc.setFontSize(10);
              doc.setFont("helvetica", "bold");
              doc.text(`${field.label}:`, moneySectionX + 12, rowY);
              doc.setFont("helvetica", "normal");
              doc.text(field.value, moneySectionX + moneySectionWidth - 10, rowY, { align: 'right' });
            });
      
            // Items Section Header
            const itemsTitleY = moneySectionStartY + moneySectionHeight + 6;
            doc.setFontSize(14);
            doc.text('Items', pageMargin, itemsTitleY);
            doc.setLineWidth(0.5);
            doc.line(pageMargin, itemsTitleY + 2, pageWidth - pageMargin, itemsTitleY + 2);
          };
      
          // Prepare table data
          const tableColumn = ["Item Name", "Quantity", "Unit Price", "VAT%", "VAT", "Total"];
          const tableRows = order.items.map(item => [
            item.name,
            item.quantity.toString(),
            formatCurrency(item.unitPrice || 0),
            item.vatPercent.toString(),
            formatCurrency(item.vat || 0),
            formatCurrency(item.total || 0),
          ]);
      
          // Generate table with repeating header
          doc.autoTable({
            startY: headerHeight - 10,
            margin: { top: headerHeight },
            head: [tableColumn],
            body: tableRows,
            theme: 'grid',
            headStyles: {
              fillColor: [79, 129, 189],
              textColor: 255,
              fontSize: 10,
              align: 'center'
            },
            bodyStyles: { fontSize: 10 },
            willDrawPage: (data) => {
              // Draw header on every page before table
              drawHeaderAndDetails(doc);
      
              // Add page numbers
              const pageCount = doc.internal.getNumberOfPages(); // Total pages
              const currentPage = data.pageNumber; // Current page number
      
              // Position the page number opposite the "Items" heading
              const pageNumberX = pageWidth - pageMargin - 20; // Right-aligned
              const pageNumberY = headerHeight - 15; // Adjust Y position as needed
      
              doc.setFontSize(10);
              doc.text(`Page ${currentPage} of ${pageCount}`, pageNumberX, pageNumberY);
            }
          });
      
          // Save PDF
          doc.save(`purchase_order_${order.orderCode}.pdf`);
        };
      };
      useEffect(() => {
                  message.config({
                    top: window.innerHeight - 100, 
                    duration: 3, 
                  });
        }, []);
      
      
  return (
        <div className={classes.dataSheet}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: '10px' }}>
            <h3 style={{margin: 0}}>{`${id > 0 ? 'Update': "Add"} Purchase Order`}</h3>
            {
              id > 0 && (
                <div style={{ display: 'flex', alignItems: 'center'}}>
                  <>
                <Tooltip title="Download PDF">
                <CloudDownloadOutlined
                style={{ fontSize: '25px', color: '#1677FF'}}
                onClick={generatePurchaseOrderPDF}
                 />
                 </Tooltip>
                 </>
                {/* {
                  purchaseOrderDetail?.work_order_id > 0 && (

                    <Button type="link" onClick={()=> navigate(`/workshop_work_order/${purchaseOrderDetail?.work_order_id}`)}>View Work Order</Button>
                  )
                } */}
                 </div>
              )
            }
        </div>
        <>
          <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Code
            </span>
                <Input 
                value={purchaseOrderDetail?.order_code}
                disabled
                placeholder='To be generated'
                 />
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
              <span>
                Date<span style={{ color: "red", fontSize: "15px" }}>*</span>:
              </span>
              <DatePicker
                format={DATE_FORMAT}
                value={purchaseOrderDetail.date ? dayjs(purchaseOrderDetail.date) : null}
                onChange={(date) => {
                  const nativeDate = date ? date.toDate() : null;
                  setPurchaseOrderDetail((prevDetails) => ({
                      ...prevDetails,
                      date: nativeDate ? dayjs(nativeDate).format(DEFAULT_DATE_FORMAT) : null,
                    }))
                }}
                // showTime
                style={{
                  width: "100%",
                }}
                placeholder="Date"
                disabled={purchaseOrderDetail?.completed}

              />
              </Col>
            
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Supplier<span style={{ color: "red" }}>*</span>
            </span>
            <Select
              style={{
                width: "100%",
              }}
              showSearch
              value={purchaseOrderDetail.supplier}
              placeholder="Supplier"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                setPurchaseOrderDetail((prevDetails) => ({
                  ...prevDetails,
                  supplier: value,
                }))
              }}
              disabled={purchaseOrderDetail?.completed}

            >
              {InventorySuppliers.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item?.title}
                </Option>
              ))}
            </Select>
            </Col>
           
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                    <span>
                                      Work Order
                                    </span>
                                    <Select
                          style={{
                            width: "100%",
                          }}
                          showSearch
                          suffixIcon={
                            <>
                            {id > 0 && purchaseOrderDetail?.work_order_id  && (
                              <Tooltip title="Go to Linked Work Order">
                              <ExportOutlined  onClick={()=> navigate(`/workshop_work_order/${purchaseOrderDetail?.work_order_id}`)} style={{color: '#5b5858', fontSize: '25px' }} />
                              </Tooltip>
                            )}
                            </>
                        }
                          value={purchaseOrderDetail.work_order_id}
                          placeholder="Link Work Order"
                          filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input?.toLowerCase())
                          }
                          onChange={(value) => {
                            setPurchaseOrderDetail((prevDetails) => ({
                              ...prevDetails,
                              work_order_id: value,
                            }))
                          }}
                          disabled={purchaseOrderDetail?.completed}
                          
                        >
                          {allWorkOrders?.map((item) => (
                            <Option key={item?.id} value={item?.id}>
                              {`${item?.work_order_code} - ${item?.title}`}
                            </Option>
                          ))}
                        </Select>
                        </Col>
            
          </Row>
          <Row style={{marginTop: '5px'}} gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <span>
              Notes:
            </span>
                {/* <TextArea 
                value={purchaseOrderDetail?.notes}
                onChange={(e) => {
                    setPurchaseOrderDetail((prevDetails) => ({
                        ...prevDetails,
                        notes: e.target.value,
                    }))
                }}
                placeholder='Please enter any notes.'
                autoSize={{ minRows: 3, maxRows: 6 }} /> */}
                <TextEditor 
              value={purchaseOrderDetail?.notes}
              onChange={(value) => {
                setPurchaseOrderDetail((prevDetails) => ({
                  ...prevDetails,
                  notes: value,
                }))
              }}
              readOnly={purchaseOrderDetail?.completed}
              />
            </Col>
            </Row>
          <Divider />

          <>
          <div>
        <UploadButton
          component="label"
          variant="contained"
          sx={{ marginTop: "10px" }}
          startIcon={<CloudUploadIcon />}
        >
          Add files
          <input
            type="file"
            hidden
            multiple
            capture
            onChange={(e) => {
                const myfiles = e.target.files;
            
                if (myfiles.length > 10) {
                  message.error("A maximum of 10 images can be uploaded at a time.");
                  e.target.value = "";
                } else {
                  handleSubmitImage(e);
                }
              }}
          />
        </UploadButton>
      </div>

      {currentItemFiles?.length > 0 && <h4>Old Files:</h4>}
      <ul>
                  {currentItemFiles?.length > 0 &&
                    currentItemFiles
                      .filter(
                        (item) =>
                          !files.some((file) => file.name === item)
                      )
                      .map((item) => {
                        const encodedFileName = item.replace(/\+/g, '%2B');
                        return (
                          <li>
                                <IconButton
                                  aria-label="delete"
                                  color="primary"
                                  onClick={() => handleDeleteCurrentFile(item)}
                                >
                                  <DeleteIcon />
                                </IconButton>

                            <a
                              href={`${tms_uploads_cdn}/${env}/purchase-orders/${id}/${encodedFileName}`}
                              target="_blank"
                            >
                              {extractOriginalFileName(encodedFileName)}
                            </a>
                          </li>
                        );
                      })}
                </ul>
        
      {files?.length > 0 && <Divider />}

      {files?.length > 0 && <h4>New Files:</h4>}
                <ul>
                  {files.length > 0 &&
                    files.map((files) => {
                      const encodedFileName = files?.name.replace(/\+/g, '%2B');
                      return (
                        <li>
                          {" "}
                          <IconButton
                            aria-label="delete"
                            color="primary"
                            onClick={() => handleDeleteFile(files.name)}
                          >
                            <DeleteIcon />
                          </IconButton>
                          {extractOriginalFileName(encodedFileName)}
                        </li>
                      );
                    })}
                </ul>
      {files?.length > 0 && <Divider />}

          <div>
          
            <Row  style={{display: 'flex', justifyContent: 'end', marginBottom: '15px'}} gutter={[16, 16]}>
              {
                data.map((item, index) => (
                  <Col xs={24} sm={12} md={8} lg={8} xl={4} key={index}>
                    <Card title={item?.title}>{item?.value}</Card>
                  </Col>
                ))
              }
            </Row>
  </div>
         <div style={{marginTop: '10px'}}>
         <Row gutter={[6, 4]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
              <h5 style={{ margin: '0px 0px 5px 5px' }}>Item <span style={{ color: "red", fontSize: "10px" }}>*</span></h5>
            </Col>
           
            <Col xs={24} sm={12} md={3} lg={3} xl={3}>
              <h5 style={{ margin: '0px 0px 5px 5px' }}>Quantity <span style={{ color: "red", fontSize: "10px" }}>*</span></h5>
            </Col>
            <Col xs={24} sm={12} md={3} lg={3} xl={3}>
              <h5 style={{ margin: '0px 0px 5px 5px' }}>{`Unit Price (£)`}</h5>
            </Col>
            <Col xs={24} sm={12} md={3} lg={3} xl={3}>
              <h5 style={{ margin: '0px 0px 5px 5px' }}>VAT %</h5>
            </Col>
            <Col xs={24} sm={12} md={3} lg={3} xl={3}>
              <h5 style={{ margin: '0px 0px 5px 5px' }}>{`VAT (£)`}</h5>
            </Col>
            <Col xs={24} sm={12} md={3} lg={3} xl={3}>
              <h5 style={{ margin: '0px 0px 5px 5px' }}>{`Total (£)`}</h5>
            </Col>
              {orderItems?.length > 1 && !purchaseOrderDetail?.completed && (
              <Col xs={24} sm={12} md={1} lg={1} xl={1}>
                <h5 style={{ margin: '0px 0px 5px 5px' }}>Action</h5>
              </Col>
            )}
          </Row>
          
              {orderItems.map((orderItem, index) => (
                <div key={index}>
                  <Row gutter={[6, 4]} style={{ marginTop: '5px' }}>
                  <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                  {/* <h5 style={{ margin: "1px 0px" }}>
                        Item
                      </h5> */}
                  <Select
              style={{
                width: "100%",
              }}
              showSearch
              name="order_item"
              value={orderItem?.order_item}
              placeholder="Please Select"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                const isAlreadySelected = orderItems.some(
                  (item) => item.order_item === value
                );

                if (isAlreadySelected) {
                  message.error("This item is already selected. Please choose another item.");
                  return;
                }
                const item = allItems?.find(item => item.id == value)
                console.log();
                
                const list = [...orderItems];
                list[index].order_item = value;
                list[index].order_item_unit_price = item?.unit_price ? item?.unit_price : ''
                setOrderItems(list);
              }}
              disabled={purchaseOrderDetail?.completed}
              
            >
              {allItems.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.item_name}
                </Option>
              ))}
            </Select>
                    </Col>
                    
                    
                    <Col xs={24} sm={12} md={3} lg={3} xl={3}>
                      {/* <h5 style={{ margin: "1px 0px" }}>
                        Quantity
                        <span style={{ color: "red", fontSize: "10px" }}>
                          *
                        </span>
                      </h5> */}
                      <Input
                        name="order_item_quantity"
                        type="number"
                        value={orderItem?.order_item_quantity}
                        onChange={(e) => handleInputChange(index, e)}
                        placeholder="Quantity"
                        // step="0.01"
                        max={20000}
                        min={0}
              disabled={purchaseOrderDetail?.completed}

                      />
                    </Col>
                    <Col xs={24} sm={12} md={3} lg={3} xl={3}>
                      {/* <h5 style={{ margin: "1px 0px" }}>
                        Unit Price
                        <span style={{ color: "red", fontSize: "10px" }}>
                          *
                        </span>
                      </h5> */}
                      <Input
                        name="order_item_unit_price"
                        type="number"
                        value={orderItem?.order_item_unit_price}
                        onChange={(e) => handleInputChange(index, e)}
                        placeholder="Unit Price"
                        step="0.01"
                        max={20000}
                        min={0}
              disabled={purchaseOrderDetail?.completed}

                      />
                    </Col>
                    <Col xs={24} sm={12} md={3} lg={3} xl={3}>
                  {/* <h5 style={{ margin: "1px 0px" }}>
                        VAT %
                      </h5> */}
                  <Select
              style={{
                width: "100%",
              }}
              showSearch
              name="vat_percentage"
              value={orderItem?.vat_percentage}
              placeholder="Please Select"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                const list = [...orderItems];
                list[index].vat_percentage = value;
                const item = list[index];
                const quantity = parseFloat(item.order_item_quantity || 0);
                const unitPrice = parseFloat(item.order_item_unit_price || 0);
              
                const vatAmount = quantity * unitPrice;
              
                const vat_percentageItem = VATPercentages.find((vatItem) => vatItem.id == item.vat_percentage)
                
                const vatPercentage = Number(vat_percentageItem?.percent || 0) / 100;
                const calculatedVat = vatAmount * vatPercentage;
              
                const total = vatAmount + calculatedVat;
              
                list[index].order_item_vat = calculatedVat.toFixed(2); 
                list[index].order_item_total = total.toFixed(2); 
              
                setOrderItems(list);
              }}
              disabled={purchaseOrderDetail?.completed}
            >
              {VATPercentages.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.title}
                </Option>
              ))}
            </Select>
                    </Col>
                    <Col xs={24} sm={12} md={3} lg={3} xl={3}>
                      {/* <h5 style={{ margin: "1px 0px" }}>
                        VAT
                        <span style={{ color: "red", fontSize: "10px" }}>
                          *
                        </span>
                      </h5> */}
                      <Input
                        name="order_item_vat"
                        type="number"
                        value={orderItem?.order_item_vat}
                        // onChange={(e) => handleInputChange(index, e)}
                        disabled
                        placeholder="VAT"
                        step="0.01"
                        max={20000}
                        min={0}
                        

                      />
                    </Col>
                    <Col xs={24} sm={12} md={3} lg={3} xl={3}>
                      {/* <h5 style={{ margin: "1px 0px" }}>
                        Total
                        <span style={{ color: "red", fontSize: "10px" }}>
                          *
                        </span>
                      </h5> */}
                      <Input
                        name="order_item_total"
                        type="number"
                        value={orderItem?.order_item_total}
                        placeholder="Total"
                        step="0.01"
                        disabled
                        
                      />
                    </Col>
                    {orderItems.length > 1 && (
                  <Col xs={24} sm={12} md={1} lg={1} xl={1}>
                    {
                      purchaseOrderDetail?.completed ? null : (
                        <>
                        {orderItem?.order_item > 0 ? (
                      <Popconfirm
                        title="Remove Item"
                        description="Are you sure you want to remove this Item?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={() => handleRemoveItem(index, orderItem)}
                      >
                        <DeleteFilled style={{ fontSize: '25px', color: 'red' }} />
                      </Popconfirm>
                    ) : (
                      <DeleteFilled
                        onClick={() => handleRemoveItem(index, orderItem)}
                        style={{ fontSize: '25px', color: 'red' }}
                      />
                    )}
                        </>
                      )
                    }
                    
                  </Col>
                )}
                  </Row>

                </div>
              ))}
              {
                !purchaseOrderDetail?.completed && (
                  <Row>
            <Col>
              <Button
                type="dashed"
                onClick={handleAddItem}
                block
                icon={<PlusOutlined />}
                style={{ marginTop: "10px" }}
              >
                Add Another Item
              </Button>
            </Col>
          </Row>
                )
              }
              
            </div>
       
        </>
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
        >
          <Button
            onClick={() => navigate("/workshop_purchase_order")}
            danger
            size="large"
            style={{ marginRight: "10px" }}
          >
            Cancel
          </Button>
          {
            !purchaseOrderDetail?.completed && (
              <Button
              type="primary"
              size="large"
              style={{ marginRight: "10px" }}
              onClick={handleSubmitPurchaseOrder}
            >
              Save
            </Button>
            )

          }

{
            !purchaseOrderDetail?.completed && id > 0 && (
              <Button
              type="primary"
              size="large"
              onClick={()=>{
                Modal.confirm({
                  title: 'Post Purchase Order',
                  centered: true,
                  content: `Are you sure you want to post this purchase order?`,
                  onOk: handlePostPurchaseOrder,
                  okText: 'Post',
                  cancelText: 'Cancel',
                  width: 600,
                  okButtonProps: { size: "large"  },
                  cancelButtonProps: { size: "large" },
                });
              }}
            >
              Post
            </Button>
            )

          }
            
           
        </div>
        </>
          <Message type={type} msg={loadMessage} />
      </div>
      
  )
}

export default PurchaseOrder
